module.exports = __webpack_public_path__ + "static/img/404(1).a08bdfcf.jpg";